import { Button, Input, Typography } from '@evocolabs/orkaui'
import { FormControl, Box } from '@mui/material'
import React, { useRef, useState } from 'react'

import i18n from 'i18next'
import k from './../../i18n/keys'
import theme from '@evocolabs/orkaui/lib/theme.cjs'
import { useBackend } from '@/src/providers/BackendProvider'
import useEnterKey from 'src/utils/EnterKeyHandler'
import validateEmail from '@/src/utils/validateEmail'
import { useRouter } from 'next/router'

const LogIn = ({
  setCurrentView,
  checkoutText,
  logInEmail,
  setLogInEmail,
  ...props
}) => {
  const [p3Values, setP3Values] = useState({
    password: '',
    email: '',
    showPassword: false
  })

  const [errors, setErrors] = useState({
    password: '',
    email: ''
  })
  const {
    asyncUserEmailTakenStatus,
    asyncUserEmailVerifiedStatus,
    asyncUserIsFirebaseUser,
    asyncUserLogIn,
    sendVerifyEmail
  } = useBackend()
  const router = useRouter()
  checkoutText = checkoutText === '' ? 'Log in to Orka' : checkoutText
  const accountSignInButtonRef = useRef(null)

  const checkInfo = () => {
    return (
      !errors.password &&
      !errors.email &&
      p3Values.password.length >= 6 &&
      p3Values.email !== ''
    )
  }

  const handleLoginFailed = () => {
    setErrors((prevErrors) => {
      return {
        ...prevErrors,
        password:
          'The username or password you have entered is incorrect. Please try again.'
      }
    })
  }

  const continueOnClick = async () => {
    if (checkInfo()) {
      sessionStorage.setItem('logInEmail', p3Values.email)
      setLogInEmail(p3Values.email)
      if (!(await asyncUserEmailTakenStatus(p3Values.email))) {
        setErrors((prevErrors) => {
          return {
            ...prevErrors,
            password: i18n.t(k.WRONG_PASSWORD_TRY_AGAIN_OR_C)
          }
        })
      } else if (!(await asyncUserEmailVerifiedStatus(p3Values.email))) {
        if (await asyncUserIsFirebaseUser(p3Values.email)) {
          sendVerifyEmail(p3Values.email)
          setCurrentView('FirebaseVerifyEmail')
        } else {
          sendVerifyEmail(p3Values.email)
          router.push('/SignIn/UnverifiedVerifyEmail')
        }
      }
      try {
        const res = await asyncUserLogIn(p3Values.email, p3Values.password)
        if (!res) {
          handleLoginFailed()
          return false
        }
        const queryString = new URLSearchParams(window.location.search)
        if (queryString.get('OrderNum')) {
          setTimeout(() => {
            window.location.href = '/Checkout' + window.location.search
          }, 100)
        } else {
          const redirect_uri = queryString.get('redirect_uri')
          setTimeout(() => {
            window.location.href = redirect_uri || '/Account'
          }, 100)
        }
        return true
      } catch (e) {
        handleLoginFailed()
      }
    } else {
      if (p3Values.email === '') {
        setErrors((latestErrors) => {
          return {
            ...latestErrors,
            email: i18n.t(k.EMPTY_EMAIL_ADDRESS_REQUIRED)
          }
        })
      }
      if (p3Values.password.length < 6) {
        setErrors((latestErrors) => {
          return {
            ...latestErrors,
            password: i18n.t(k.MUST_BE_CHARACTERS_OR_MORE)
          }
        })
      }
    }
  }

  const handleChange = (prop) => (event) => {
    setP3Values({ ...p3Values, [prop]: event.target.value })
    setErrors({})
  }

  const handleReg = () => {
    router.push('/SignIn/CreateAccount')
  }

  const handleForgot = () => {
    router.push('/SignIn/forgetPassword')
  }

  useEnterKey(accountSignInButtonRef)

  return (
    <Box display={'flex'} gap={4} flexDirection={'column'}>
      <Typography variant="h4" id="checkoutText">
        {checkoutText}
      </Typography>
      <Box width="100%" display={'flex'} gap={1} flexDirection={'column'}>
        <Box display="flex" gap={2} flexDirection={'column'}>
          <FormControl width="100%">
            <Input
              id="outlined-adornment-emailaddress"
              placeholder="Email Address"
              required
              type="email"
              onChange={handleChange('email')}
              errormsg={errors.email}
              fullWidth
              onBlur={() => {
                if (!validateEmail(p3Values.email)) {
                  setErrors((latestErrors) => {
                    return {
                      ...latestErrors,
                      email: i18n.t(k.INVALID_EMAIL_ADDRESS1)
                    }
                  })
                }
                if (p3Values.email === '') {
                  setErrors((latestErrors) => {
                    return {
                      ...latestErrors,
                      email: i18n.t(k.EMPTY_EMAIL_ADDRESS_REQUIRED)
                    }
                  })
                }
              }}
            />
          </FormControl>
          <FormControl>
            <Input
              id="filled-adornment-password"
              placeholder="Password"
              type="password"
              required
              fullWidth
              onChange={handleChange('password')}
              errormsg={errors.password}
              onBlur={() => {
                if (p3Values.password.length < 6) {
                  setErrors((latestErrors) => {
                    return {
                      ...latestErrors,
                      password: i18n.t(k.MUST_BE_CHARACTERS_OR_MORE)
                    }
                  })
                }
              }}
            />
          </FormControl>
        </Box>
        <Typography variant="Link" textAlign="right">
          <span onClick={handleForgot}>{i18n.t(k.FORGOT_PASSWORD)}</span>
        </Typography>
      </Box>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Box
          display={'flex'}
          flexDirection={'column'}
          gap={1}
          alignItems={'center'}
        >
          <Button
            color="primary"
            variant="primary"
            size="large"
            handleClick={continueOnClick}
            loadable
            id="login"
            width="184px"
          >
            {i18n.t(k.LOG_IN)}
          </Button>
          <Typography variant="body3" color={theme.palette.gray[700]}>
            {i18n.t(k.NEW_TO_ORKA)}{' '}
            <Typography
              onClick={handleReg}
              variant="Link"
              color={theme.palette.multicolor[300]}
            >
              {i18n.t(k.CREATE_ACCOUNT2)}
            </Typography>
          </Typography>
        </Box>
      </div>
    </Box>
  )
}

export default LogIn
